//地図のアクティブ・非アクティブ化
$(function() {
    //地図をホバー
    const maps = $('#Japan').find('.maps');
    maps.on('mouseenter mouseleave', function() {
        var area = $(this).data('area');
        const elements = $("[data-area='" + area + "']");
        elements.toggleClass('is-active');
    });

    //リストをホバー
    const list = $('.store-list__item');
    list.on('mouseenter mouseleave', function() {
        var area = $(this).data('area');
        const elements = $("[data-area='" + area + "']");
        elements.toggleClass('is-active');
    });
});

//スムーススクロール
$(function() {
    $('a[href^="#"]').on('click', function() {
        console.log('aaa');
        const speed = 500;
        const href = $(this).attr('href');
        const target = $(href == "#" || href == "" ? 'html' : href);
        const header = $('header').height();
        const position = target.offset().top - header - 60;
        $('html, body').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });
});

//flickity
$(function() {
    $('.main-carousel').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        autoPlay: true,
        wrapAround: true
    });
});